export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/deleteFreeYoutubeVideo',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allFreeVideos'],
       
    })
